import { MenuItem } from '@shared/core';

export const mclMenuItems: MenuItem[] = [
    {
        id: 'home',
        name: $localize`Services`,
        icon: 'stethoscope',
        link: '/main/home',
        fragment: '',
        unread: false,
    },
    {
        id: 'reservations',
        name: $localize`Reservations`,
        icon: 'calendar',
        link: '/main/booking/list',
        fragment: '',
        unread: false,
    },
    {
        id: 'profile',
        name: $localize`Profile`,
        icon: 'user',
        link: '/main/profile',
        fragment: '',
        unread: false,
    },
];
